'use client'

import { useCallback } from 'react'
import { useSearchParams } from 'next/navigation'

export default function useCollectionUrlState<T extends string>(key: string, fallback: T, values: readonly T[], enabled = true): [T, (value: T) => void] {
 const params = useSearchParams()
 const candidate = params.get(key) as T | null
 const value = enabled && candidate && values.includes(candidate) ? candidate : fallback
 const update = useCallback((next: T) => {
  if (!enabled) return
  const url = new URL(window.location.href)
  if (url.searchParams.get(key) === next) return
  url.searchParams.set(key, next)
  window.history.pushState(null, '', url.pathname + url.search + url.hash)
 }, [key, enabled])
 return [value, update]
}
